import { useSearchParams } from 'react-router';
import { FullScreenSpinner } from '@/components/ui';
import { longDate } from '@/lib/format';
import { useDataDeletionStatus } from '@/lib/queries';
import { AuthLayout } from './auth/AuthLayout';

/** The status page Meta links people to after they ask Facebook to delete their data. */
export function DataDeletion() {
  const [params] = useSearchParams();
  const code = params.get('code');
  const status = useDataDeletionStatus(code);
  if (code && status.isPending) return <FullScreenSpinner />;
  const found = code && status.data ? status.data : null;
  return (
    <AuthLayout title="Data deletion">
      {found ? (
        <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.55 }}>
          Your request {code} is complete: we deleted the data linked to your Facebook account on{' '}
          {longDate(found.requestedAt)}.
        </p>
      ) : (
        <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.55 }}>
          We don't have a request with that code. To delete your STR Leads Social account, sign in
          and open Settings, or email{' '}
          <a href="mailto:privacy@str-leads.com">privacy@str-leads.com</a>.
        </p>
      )}
    </AuthLayout>
  );
}
